import { toast } from 'sonner'

export type ConfirmToastOptions = {
	message: string
	onConfirm: () => void
	onCancel?: () => void
	confirmLabel?: string
	cancelLabel?: string
}

export const ToastConfirm = ({
	message,
	onConfirm,
	onCancel = () => {},
	confirmLabel = 'Sí',
	cancelLabel = 'No',
}: ConfirmToastOptions): string | number => {
	const id = toast.custom(
		(t) => (
			<div className='relative bg-white text-black px-6 py-5 rounded-lg border border-neutral-200 shadow-sm max-w-md w-full flex flex-col gap-5 text-base font-normal tracking-tight leading-relaxed'>
				<button
					onClick={() => toast.dismiss(t)}
					className='absolute top-3 right-3 text-black text-lg hover:opacity-50 transition-opacity'
					aria-label='Cerrar'
				>
					✕
				</button>

				<div className='pr-6'>{message}</div>

				<div className='flex justify-end gap-3 pt-1'>
					<button
						onClick={() => {
							toast.dismiss(t)
							onCancel()
						}}
						className='px-4 py-2 rounded-md border border-neutral-300 text-black hover:bg-neutral-100 transition-colors cursor-pointer'
					>
						{cancelLabel}
					</button>
					<button
						onClick={() => {
							toast.dismiss(t)
							onConfirm()
						}}
						className='px-4 py-2 rounded-md bg-black text-white hover:bg-white hover:text-black border border-black transition-colors cursor-pointer'
					>
						{confirmLabel}
					</button>
				</div>
			</div>
		),
		{ duration: Infinity }
	)

	return id
}
